import { useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilterForm,
  setIsSearch,
  setFilterFormDateRangeError,
} from "../../redux/booking/booking-slice";
import { twMerge } from "tailwind-merge";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { AnimatePresence, motion } from "framer-motion";

const Backdrop = ({ onModalOff }) => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const { filterForm: formData, filterFormDateRangeError } = useSelector(
    (state) => state.booking
  );

  const handleClick = () => {
    const payload = {
      token: token,
      affiliateId: user?._id,
      ...formData,
    };

    if (
      (payload.dateType === "date-range" && !payload.startDate) ||
      (payload.dateType === "date-range" && !payload.endDate)
    ) {
      dispatch(setFilterFormDateRangeError(true));
    } else {
      dispatch(setFilterFormDateRangeError(false));
      dispatch(setIsSearch({ isSearch: true }));
      dispatch({
        type: "FILTER_AFFILIATE_COMPLETE",
        payload,
      });
      onModalOff();
    }
  };
  return (
    <div
      className="fixed left-0 z-50 bg-black opacity-70 w-full min-h-screen"
      onClick={handleClick}
    />
  );
};

const Input = forwardRef(({ className, label, ...props }, ref) => {
  return (
    <div className="space-y-[6px]">
      <label className="text-[13px] text-white" htmlFor={label}>
        {label}
      </label>
      <input
        ref={ref}
        id={label}
        className={twMerge(
          "bg-black border border-[rgba(228,228,228,0.60)] focus:border-white hover:border-white p-2 text-[11px] rounded-[5px] placeholder:text-[#848484] w-full outline-none placeholder:text-[11px]",
          className
        )}
        {...props}
      />
    </div>
  );
});

const Modal = ({ onModalOff }) => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const { filterForm: formData, filterFormDateRangeError } = useSelector(
    (state) => state.booking
  );

  const onSubmit = () => {
    const payload = {
      token: token,
      affiliateId: user?._id,
      ...formData,
    };

    if (
      (payload.dateType === "date-range" && !payload.startDate) ||
      (payload.dateType === "date-range" && !payload.endDate)
    ) {
      dispatch(setFilterFormDateRangeError(true));
    } else {
      dispatch(setFilterFormDateRangeError(false));
      dispatch(setIsSearch({ isSearch: true }));
      dispatch({
        type: "FILTER_AFFILIATE_COMPLETE",
        payload,
      });
      onModalOff();
    }
  };

  return (
    <div className="affiliateSearchModalBg  rounded-[10px] fixed left-1/2 -translate-x-1/2 top-[125px] w-[678px] z-[60] ">
      <div className="pb-[30px] space-y-[15px]  relative rounded-[10px] w-full h-full ">
        <div className="m-1 flex justify-between items-center bg-[linear-gradient(269deg,#000_-9.66%,_rgba(62,62,62,0.94)44.38%,rgba(0,0,0,0.80)103.14%)]">
          <h2 className="w-full text-white text-[20px] leading-[18px] font-semibold pt-[20px] pl-[30px] pb-[18px]">
            Search by filter
          </h2>
        </div>
        <div className="mt-[20px] mx-[30px] mb-[30px] space-y-[15px]">
          <div className="w-full space-x-4 flex justify-between">
            <div className="w-1/2 space-y-4">
              <p className="text-white text-[13px] ">
                Select Travel date or range date
              </p>
              <div className="flex space-x-8">
                <div
                  className="group flex space-x-[10px] justify-between items-center cursor-pointer"
                  onClick={() => {
                    dispatch(
                      setFilterForm({
                        singleDate: "",
                        startDate: "",
                        endDate: "",
                        dateType: "travel-date",
                      })
                    );
                  }}
                >
                  <div
                    className="flex items-center space-x-2"
                    onClick={() => dispatch(setFilterFormDateRangeError())}
                  >
                    <input
                      type="radio"
                      name="radio-1"
                      className={twMerge(
                        `size-5 radio checked:bg-white border-[rgba(228,228,228,0.60)] group-hover:border-white`,
                        formData.dateType === "travel-date" && "border-white "
                      )}
                      checked={formData.dateType === "travel-date"}
                    />
                    <span
                      className={twMerge(
                        `-translate-y-[1px] text-[16px] font-medium text-[rgba(228,228,228,0.60)] group-hover:text-white`,
                        formData.dateType === "travel-date" && "text-white"
                      )}
                    >
                      Travel date
                    </span>
                  </div>
                </div>
                <div
                  className="group flex space-x-[10px] justify-between items-center cursor-pointer"
                  onClick={() => {
                    dispatch(
                      setFilterForm({
                        singleDate: "",
                        startDate: "",
                        endDate: "",
                        dateType: "date-range",
                      })
                    );
                  }}
                >
                  <div className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="radio-1"
                      className={twMerge(
                        `size-5 radio checked:bg-white border-[rgba(228,228,228,0.60)] group-hover:border-white`,
                        formData.dateType === "date-range" && "border-white "
                      )}
                      checked={formData.dateType === "date-range"}
                    />
                    <span
                      className={twMerge(
                        `-translate-y-[1px] text-[16px] font-medium text-[rgba(228,228,228,0.60)] group-hover:text-white`,
                        formData.dateType === "date-range" && "text-white"
                      )}
                    >
                      Date Range
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-1/2">
              {formData.dateType === "travel-date" ? (
                <div className="space-y-[6px]">
                  <label className="text-[13px] text-white">Travel Date</label>

                  <Calendar
                    dateFormat="dd/mm/yy"
                    className="hover:border-white bg-black border border-[rgba(228,228,228,0.60)] p-2 text-[11px] rounded-[5px] placeholder:text-[#848484] w-full outline-none placeholder:text-[11px]"
                    variant="filled"
                    inputClassName="bg-black outline-none"
                    placeholder="Select Travel date"
                    panelClassName=""
                    panelStyle={{
                      backgroundColor: "black",
                      borderColor: "gray",
                      borderWidth: "1px",
                      width: "300px",
                      height: "230px",
                    }}
                    value={formData.singleDate}
                    showOtherMonths={false}
                    onChange={(e) => {
                      dispatch(
                        setFilterForm({
                          singleDate: e.value,
                        })
                      );
                    }}
                  />
                </div>
              ) : (
                <div className="flex space-x-2">
                  <div className="space-y-[6px]">
                    <label className="text-[13px] text-white">Start Date</label>
                    <Calendar
                      dateFormat="dd/mm/yy"
                      className=" hover:border-white bg-black border border-[rgba(228,228,228,0.60)] p-2 text-[11px] rounded-[5px] placeholder:text-[#848484] w-full outline-none placeholder:text-[11px]"
                      variant="filled"
                      inputClassName="bg-black outline-none focus:border-white"
                      placeholder="Select Start date"
                      panelStyle={{
                        backgroundColor: "black",
                        borderColor: "gray",
                        borderWidth: "1px",
                        width: "283px",
                        height: "206px",
                      }}
                      maxDate={formData.endDate}
                      value={formData.startDate}
                      showOtherMonths={false}
                      onChange={(e) => {
                        dispatch(
                          setFilterForm({
                            startDate: e.value,
                          })
                        );
                      }}
                    />
                  </div>
                  <div className="space-y-[6px]">
                    <label className="text-[13px] text-white">End Date</label>
                    <Calendar
                      dateFormat="dd/mm/yy"
                      className=" hover:border-white bg-black border border-[rgba(228,228,228,0.60)] p-2 text-[11px] rounded-[5px] placeholder:text-[#848484] w-full outline-none placeholder:text-[11px]"
                      variant="filled"
                      inputClassName="bg-black outline-none"
                      placeholder="Select End date"
                      panelStyle={{
                        backgroundColor: "black",
                        borderColor: "gray",
                        borderWidth: "1px",
                        width: "283px",
                        height: "206px",
                      }}
                      showOtherMonths={false}
                      minDate={formData.startDate}
                      value={formData.endDate}
                      onChange={(e) => {
                        dispatch(
                          setFilterForm({
                            endDate: e.value,
                          })
                        );
                      }}
                    />
                  </div>
                </div>
              )}
              <AnimatePresence>
                {filterFormDateRangeError && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 100, height: 16 }}
                    exit={{ opacity: 0, height: 0 }}
                    className="text-red-500"
                  >
                    Please Select Both Start and End Date
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>

          <div className="w-full flex justify-center space-x-4">
            <div className="w-1/2">
              <Input
                autoComplete="off"
                onChange={(e) =>
                  dispatch(setFilterForm({ passengerName: e.target.value }))
                }
                value={formData?.passengerName}
                label="Passenger Name"
                placeholder="Enter Passenger Name"
              />
            </div>
            <div className="w-1/2">
              <Input
                autoComplete="off"
                onChange={(e) =>
                  dispatch(setFilterForm({ driverName: e.target.value }))
                }
                value={formData?.driverName}
                label="Driver Name"
                placeholder="Enter Driver Name"
              />
            </div>
          </div>

          <div className="w-full">
            <Input
              autoComplete="off"
              onChange={(e) =>
                dispatch(setFilterForm({ bookingId: e.target.value }))
              }
              value={formData?.bookingId}
              label="Booking ID"
              placeholder="Enter Booking ID"
            />
          </div>

          <div className="flex justify-center space-x-4">
            <button
              type="button"
              onClick={onModalOff}
              className="text-white font-medium text-[14px] py-[9px] w-[130px] bg-[#181E29] hover:bg-[#2f3646] border-2 border-[#353C4A] rounded-[5px]"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSubmit}
              className="text-white font-medium text-[14px] py-[9px] w-[130px] bg-[#144EE3] hover:bg-blue-800 border border-[#353C4A] rounded-[5px]"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const FilterForm = ({ onModalOff }) => {
  return (
    <>
      <Backdrop onModalOff={onModalOff} />
      <Modal onModalOff={onModalOff} />
    </>
  );
};

export default FilterForm;
